import pure from "./higher-order/pure";
import classes from "../classes";
import React from "react";

export default pure(function Badge({color, ghost, icon, iconOnly, text}) {
  if (color) {
    var badgeClassColor = "badge--" + color;
  }
  var message;
  if (!iconOnly) {
    message = (
      <span>
        {text}
      </span>
    );
  }
  return (
    <span
      className={classes({
        "badge": true,
        "badge--ghost": ghost,
        "badge--icon": iconOnly,
        [`${badgeClassColor}`]: badgeClassColor,
        "tooltip": iconOnly
      })}
      data-tooltip={text}>
      <i className={classes({
        ["dw-" + `${icon}` + " dw--1-25x"]: true
      })} />

      {" "}

      {message}
    </span>
  );
});
